import type {CSSProperties} from 'react';
import {WEDGE_SUBSCRIPTION as S} from '@territory/tokens';
import {wedgeExactRole} from './wedgeRoles.js';

export type WedgeSubscriptionPlanLook = 'subscription-plan-amber' | 'subscription-plan-accent';

export const isWedgeSubscriptionPlanLook = (look: string | undefined): look is WedgeSubscriptionPlanLook =>
  look === 'subscription-plan-amber' || look === 'subscription-plan-accent';

/* Released notice action of the Subscription plan card (Update card on a failed payment, Resume on a paused plan): a small block with 6px by 11px
   of padding, an 8px radius, no border, 12px bold type in the Wedge font, the fixed white subscription ink and a pointer cursor. The amber look
   fills with the amber role and the accent look with the accent role. Both read the exact legacy roles and keep the declaration order of the
   source. They keep the 44px transparent target: the block is about 28px
   tall inside a banner with 10px of padding, so the 8px the target adds above and below stays inside the banner, and nothing sits beside the block. */
const PADDING = '6px 11px', RADIUS = 8, FONT = 12, WEIGHT = 700;

export function wedgeSubscriptionPlanStyle(look: WedgeSubscriptionPlanLook): CSSProperties {
  const r = wedgeExactRole;
  return {
    background: r(look === 'subscription-plan-amber' ? 'amber' : 'accent'), color: S.ink, border: 0,
    padding: PADDING, borderRadius: RADIUS,
    fontFamily: r('font'), fontSize: FONT, fontWeight: WEIGHT, cursor: 'pointer',
  };
}
